import { z } from 'zod';
import { Channel } from '.';

export const SalesOrderChannelSchema = {
  metricsUpdated: z.object({
    orderRevenue: z.number().default(0),
    arExpenses: z.number().default(0),
    totalRevenue: z.number().default(0),
    totalCogs: z.number().default(0),
    apExpenses: z.number().default(0),
    grossProfit: z.number().default(0),
    netProfit: z.number().default(0),
    grossProfitMargin: z.number().default(0),
    netProfitMargin: z.number().default(0),
    units: z.number().default(0),
    weight: z.number().default(0),
    pallets: z.number().default(0),
  }),
  // Bare ping: this topic MUST stay data-free. The org-checked token (realtime.manager.ts) gates
  // who subscribes; the authorized refetch the ping triggers is what carries data.
  expensesUpdated: z.object({ salesOrderId: z.number() }),
} as const;

export const SalesOrderChannel: Channel<number, typeof SalesOrderChannelSchema> = {
  getChannelId: (id) => `salesOrder:${id}`,
  topics: { metricsUpdated: 'metricsUpdated', expensesUpdated: 'expensesUpdated' },
  schemas: SalesOrderChannelSchema,
};
